import { getFirebase } from 'react-redux-firebase';

export type credsType = {
    email: string,
    password: string,
}


export const signIn = (creds: credsType) => {
    return (dispatch: Function, getState: Function, getFirebas: any) => {
      const firebase = getFirebase();
      firebase.auth().signInWithEmailAndPassword(creds.email, creds.password)
      .then(() => {
        dispatch({ type: 'SIGN_IN', creds });
      })
      .catch((err: any) => {
        dispatch({ type: 'Error', err });
      });
    };
}      

export const signUp = (creds: credsType) => {
    return (dispatch: Function, getState: Function, getFirebas: any) => {
      const firebase = getFirebase();
      firebase.auth().createUserWithEmailAndPassword(creds.email, creds.password) 
      .then(() => {
        dispatch({ type: 'SIGN_UP', creds });
      })
      .catch((err: any) => {
        dispatch({ type: 'Error', err });
      });
      console.log( creds );
    };
}      